import React from 'react';

const PopupHelp = ({ PopupHelpString, onClose }) => {
  //console.log('cm ' + PopupHelpString);
  return (
    <div className="popup-background">
    <div className="popup">
        <div className="popup-content ">
          <div className="arcMsgBox-caption">Erklärung und weiterführende Hinweise</div>
        <p>{PopupHelpString} </p>
        <button className="arcMsgBox-button" onClick={onClose}>OK</button>
      </div>
    </div>
    </div>
  );
};

export default PopupHelp;
